import LegalDocument from '../components/legal/LegalDocument';

export default function PrivacyPage() {
    return <LegalDocument kind="privacy" />;
}
